// extracted by mini-css-extract-plugin
export default {"dateContainer":"Date-module__dateContainer__fBjGt"};